import { FlowchartNodeType, GuidelineComponent, FlowchartWidget, NewGuidelineChapter } from '@treetop/shared/model';

export enum SelectionType {
  EditorHeader = 3,
  Flowchart = 4,
  Widget = 5,
}

export interface EditorSelection {
  type: SelectionType;
  element?: NewGuidelineChapter | GuidelineComponent | FlowchartWidget | FlowchartNodeType;
  flowchartId?: string;

  widgetId?: string;
  uniqueId?: string;
}
